module.exports = __webpack_public_path__ + "static/media/MarkerApiHijau.026bf119.svg";